import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mobile-draws-section" }
const _hoisted_2 = { class: "mobile-draws-header" }
const _hoisted_3 = { class: "mobile-section-title" }
const _hoisted_4 = { class: "mobile-selected-draws-section" }
const _hoisted_5 = { class: "mobile-selected-content" }
const _hoisted_6 = {
  key: 0,
  class: "mobile-no-selection"
}
const _hoisted_7 = {
  key: 1,
  class: "mobile-selected-list"
}
const _hoisted_8 = { class: "mobile-selected-text" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "mobile-draws-container" }
const _hoisted_11 = { class: "mobile-draws-grid" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "mobile-draw-content" }
const _hoisted_14 = { class: "mobile-draw-info" }
const _hoisted_15 = { class: "mobile-draw-date" }
const _hoisted_16 = { class: "mobile-draw-time" }
const _hoisted_17 = { class: "mobile-checkbox-container" }
const _hoisted_18 = ["checked", "onChange"]
const _hoisted_19 = { class: "mobile-quick-actions" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "mobile-see-less" }

import { ref, computed, watch } from 'vue';


const __default__ = {
  name: "MobileDrawsSection",
};

interface Draw {
  event_id: string | number;
  draw_date: string;
}

interface Props {
  draws: Draw[];
  selectedDraws: boolean[];
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    draws: {},
    selectedDraws: {}
  },
  emits: ["update-selected-draws", "toggle-draw-selection"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const collapsed = ref(true);

// Computed properties
const selectedCount = computed(() => {
  return props.selectedDraws.filter(Boolean).length;
});

const selectedDrawDates = computed(() => {
  return props.draws
    .filter((_, index) => props.selectedDraws[index])
    .map(draw => draw.draw_date);
});

const formattedSelectedDraws = computed(() => {
  return selectedDrawDates.value
    .map(drawDate => {
      const date = new Date(drawDate);
      return `${formatDate(date)} ${formatTime(date)}`;
    })
    .join(', ');
});

const allSelected = computed(() => {
  return props.selectedDraws.every(Boolean);
});

// Methods
const toggleCollapsed = () => {
  collapsed.value = !collapsed.value;
};

// Ensure at least one draw is always selected
const ensureMinimumSelection = () => {
  const selectedCount = props.selectedDraws.filter(Boolean).length;
  if (selectedCount === 0 && props.draws.length > 0) {
    // Select the first draw if none are selected
    emit('update-selected-draws', 0, true);
  }
};

// Watch for changes in selectedDraws to ensure minimum selection
watch(() => props.selectedDraws, () => {
  ensureMinimumSelection();
}, { immediate: true });

const toggleDrawSelection = (index: number) => {
  emit('toggle-draw-selection', index);
};

const handleCheckboxChange = (index: number, event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update-selected-draws', index, target.checked);
};

const selectAll = () => {
  props.draws.forEach((_, index) => {
    if (!props.selectedDraws[index]) {
      emit('update-selected-draws', index, true);
    }
  });
};

const clearAll = () => {
  // Only clear if there are multiple draws selected
  // Keep at least one draw selected
  const selectedIndices = props.selectedDraws
    .map((selected, index) => selected ? index : -1)
    .filter(index => index !== -1);
  
  if (selectedIndices.length > 1) {
    // Clear all except the first one
    selectedIndices.slice(1).forEach(index => {
      emit('update-selected-draws', index, false);
    });
  }
};

const formatDate = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, "1. " + _toDisplayString(_ctx.$t('draws.selectDraws')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "mobile-selected-header",
        onClick: toggleCollapsed
      }, [
        _createElementVNode("div", _hoisted_5, [
          (selectedDrawDates.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('draws.noDrawsSelected')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(formattedSelectedDraws.value), 1)
              ]))
        ]),
        _createElementVNode("button", {
          class: "mobile-collapse-btn",
          onClick: _withModifiers(toggleCollapsed, ["stop"]),
          "aria-label": collapsed.value ? _ctx.$t('forms.expandDraws') : _ctx.$t('forms.collapseDraws')
        }, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["mobile-arrow-icon", { 'rotated': !collapsed.value }]),
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("polyline", { points: "6,9 12,15 18,9" }, null, -1)
          ]), 2))
        ], 8, _hoisted_9)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.draws, (draw, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: draw.event_id,
              class: _normalizeClass(["mobile-draw-item", { 'selected': props.selectedDraws[index] }]),
              onClick: ($event: any) => (toggleDrawSelection(index))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(formatDate(new Date(draw.draw_date))), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(formatTime(new Date(draw.draw_date))), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: props.selectedDraws[index],
                  onChange: ($event: any) => (handleCheckboxChange(index, $event)),
                  class: "mobile-checkbox"
                }, null, 40, _hoisted_18),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mobile-checkbox-custom" }, null, -1))
              ])
            ], 10, _hoisted_12))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "mobile-action-btn secondary",
            onClick: selectAll,
            disabled: allSelected.value
          }, _toDisplayString(_ctx.$t('draws.selectAll')), 9, _hoisted_20),
          _createElementVNode("button", {
            class: "mobile-action-btn secondary",
            onClick: clearAll,
            disabled: selectedCount.value <= 1
          }, _toDisplayString(_ctx.$t('common.clearAll')), 9, _hoisted_21)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", {
            class: "mobile-see-less-text",
            onClick: toggleCollapsed
          }, _toDisplayString(_ctx.$t('forms.seeLess')), 1)
        ])
      ], 512), [
        [_vShow, !collapsed.value]
      ])
    ])
  ]))
}
}

})